import { DataState, DataActionTypes, ParsedExport, DataActions } from "./types";
import { getProvider, getProviders } from "fileParsing/definitions";

// Initial state
const initialState: DataState = {
  providers: getProviders().map(([def]) => def),
  exports: [],
  counter: 0,
};

function updateExportActiveState(array: ParsedExport[], id: number) {
  return array.map((item) => {
    if (item.id !== id) {
      return item;
    }

    return {
      ...item,
      ...{ active: !item.active },
    };
  });
}

function renameExport(array: ParsedExport[], id: number, newName: string) {
  return array.map((item) => {
    if (item.id !== id) {
      return item;
    }

    return {
      ...item,
      ...{
        properties: {
          ...item.properties,
          providerName: newName,
        },
      },
    };
  });
}

// The reducer function
export function dataReducer(state = initialState, action: DataActions): DataState {
  switch (action.type) {
    case DataActionTypes.ADD_DATA: {
      const { fileProperties, providerId, workerId } = action.payload;
      const provider = getProvider(providerId);
      const newData: ParsedExport = {
        id: state.counter,
        fileProperties,
        providerId,
        properties: {
          providerName: provider.name,
          originalProviderName: provider.name,
          author: provider.author,
          url: provider.url,
          helpEn: provider.strings.en.help,
          helpDe: provider.strings.de.help,
        },
        active: true,
        datapoints: [],
        children: [],
        workerId, //data.reduce((acc: DataPoint[], val) => acc.concat(val.data), [])
      };

      return {
        ...state,
        exports: state.exports.concat(newData),
        counter: state.counter + 1,
      };
    }
    case DataActionTypes.UPDATE_PROPERTIES: {
      const { exportId, providerName, author, url, helpEn, helpDe } = action.payload;
      const ix = state.exports.findIndex(({ id }) => id === exportId);
      return {
        ...state,
        exports: Object.assign<ParsedExport[], ParsedExport[], { [ix: number]: ParsedExport }>([], state.exports, {
          [ix]: {
            ...state.exports[ix],
            properties: {
              providerName,
              originalProviderName: state.exports[ix].properties.originalProviderName, // original provider name should not be changed
              author,
              url,
              helpEn,
              helpDe,
            },
          },
        }),
      };
    }
    case DataActionTypes.REMOVE_DATA: {
      const { exportId } = action.payload;
      const removed = state.exports.find((d) => d.id === exportId);
      if (removed) {
        return {
          ...state,
          exports: state.exports.filter((d) => d.id !== exportId),
        };
      } else {
        throw new Error("could not find itemID in state");
      }
    }
    case DataActionTypes.SWITCH_ITEM: {
      return {
        ...state,
        exports: updateExportActiveState(state.exports, action.payload),
      };
    }
    case DataActionTypes.RENAME_EXPORT: {
      return {
        ...state,
        exports: renameExport(state.exports, action.payload.exportId, action.payload.newName),
      };
    }
    case DataActionTypes.SET_PRIVACY_SENSITIVITY: {
      /* const { exportId, fileId, index, value } = action.payload; */
      return state;
    }
    default: {
      return state;
    }
  }
}
